import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function HeroSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      ref={ref}
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
      aria-label="Guia Prático de Palestras Silenciosas — STIB"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/img/stib/congresso-coffee.webp"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/75 via-secondary/55 to-secondary/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        {/* Badge */}
        <div
          className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <span className="inline-block font-body text-xs font-semibold uppercase tracking-[0.25em] text-primary mb-8 bg-primary/15 border border-primary/30 px-5 py-2.5 rounded-full">
            Guia Exclusivo · Material Gratuito
          </span>
        </div>

        {/* Headline */}
        <h1
          className={`font-heading font-extrabold text-4xl md:text-6xl lg:text-8xl text-white leading-tight mb-8 transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          Guia Prático:<br />
          <span className="text-primary">Palestras Silenciosas</span>
        </h1>

        {/* Subtitle */}
        <p
          className={`font-body text-lg md:text-2xl text-white/80 max-w-2xl mx-auto leading-relaxed mb-12 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          Tudo o que você precisa saber para transformar seu evento com áudio sem fio. Dicas práticas, exemplos reais e insights que vão da contratação à execução impecável.
        </p>

        {/* Stats */}
        <div
          className={`mt-16 grid grid-cols-3 gap-8 max-w-lg mx-auto transition-all duration-700 delay-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {[
            { value: '28', label: 'páginas de conteúdo prático' },
            { value: '12', label: 'dicas de especialistas' },
            { value: '5', label: 'cases reais detalhados' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-heading font-extrabold text-3xl md:text-4xl text-primary mb-1">{stat.value}</div>
              <div className="font-body text-xs text-white/60 leading-tight">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Scroll indicator */}
        <div
          className={`mt-20 flex flex-col items-center gap-2 transition-all duration-700 delay-700 ${isVisible ? 'opacity-100' : 'opacity-0'}`}
        >
          <span className="font-body text-xs text-white/40 uppercase tracking-widest">Role para explorar</span>
          <div className="w-px h-10 bg-gradient-to-b from-white/30 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
}